//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming



export interface ArchiveItemDTO {
    filename: string;
    blob: string;
    type: string;
}

export interface ArchiveItem {
    id: number;
    filename: string;
    blob: string;
    type: string;
    createdAt: Date;
}

export interface Conversation {
    id?: string;
    debtorId?: string | undefined;
    actions?: ConversationAction[] | undefined;
    wasInterrupted?: boolean;
    interruptionReason?: string | undefined;
}

export interface ConversationAction {
    selectedDebtorClaims?: SelectedDebtorClaim[] | undefined;
    discriminator: string;
}

export interface SelectedDebtorClaim {
    providerSystem?: ProviderSystem;
    type?: string | undefined;
    number?: string | undefined;
    externalReferenceId?: number;
    balanceAmount?: number | undefined;
    invoiceFeeAmount?: number | undefined;
    noticeFeeAmount?: number | undefined;
}

export enum ProviderSystem {
    Invalid = 0,
    MMSYS1 = 1,
    MMSYS2 = 2,
    PREDATOR = 3,
    LEAP = 4,
}

export interface OtherReasonConversationAction extends ConversationAction {
    text?: string | undefined;
}

export interface SendPaymentInformationConversationAction extends ConversationAction {
    mobilePhoneNumbers?: string[] | undefined;
    emailAddresses?: string[] | undefined;
    additionalText?: string | undefined;
}

export interface SendDebtOverviewConversationAction extends ConversationAction {
    emailAddresses: string[];
    archiveIds: number[];
    additionalText?: string | undefined;
}

export interface ConfirmDebtorClaimsAsClosedAction extends ConversationAction {
}

export interface DebtorMadePaymentRecentlyAction extends ConversationAction {
}

export interface DebtorWillSendPaymentConfirmationAction extends ConversationAction {
}

export interface ObjectionConversationAction extends ConversationAction {
    reason?: string | undefined;
}

export interface RegisterCreditNoteConversationAction extends ConversationAction {
    reason?: string | undefined;
    creditType?: CreditType;
}

export enum CreditType {
    Invalid = 0,
    Full = 1,
    Fees = 2,
    InvoiceFee = 3,
    DebtCollectionNoticeFee = 4,
}

export interface RegisterPostponementConversationAction extends ConversationAction {
    reason?: string | undefined;
    postponeCode?: PostponeCode;
}

export enum PostponeCode {
    TwoWeeks = 1258,
    OneMonth = 1259,
}

export interface NoAvailablePowerOfAttorneyConversationAction extends ConversationAction {
    text?: string | undefined;
}

export interface DebtorClaimEvent {
    eventId?: string | undefined;
    leapEventId?: number;
    eventDate?: Date;
    eventName?: string | undefined;
    eventType?: ClaimEventType;
    description?: string | undefined;
    amount?: number | undefined;
    registeredBy?: string | undefined;
    data?: string | undefined;
    tooltip?: { [key: string]: string; } | undefined;
    referenceNumber?: string | undefined;
    isDocumentDispatched?: boolean;
    documentStage?: DebtorClaimStage | undefined;
    documentCode?: string | undefined;
    documentFilename?: string | undefined;
    documentId?: string | undefined;
    documentDueDate?: Date | undefined;
    discriminator: string;
}

export enum ClaimEventType {
    Undefined = 0,
    PaymentInformationSentByEmail = 1,
    PaymentInformationSentBySms = 2,
    ObjectionRegistered = 3,
    WorkflowStopped = 4,
    WorkflowStarted = 5,
    DebtCollectionWarningReturn = 6,
    DebtCollectionLetterReturn = 7,
    InvoiceReturn = 8,
    Lost = 9,
    Credit = 10,
    Letter = 11,
    Payment = 12,
    Remittance = 13,
    FullyPaidReceiptAvailable = 14,
    InvoiceFullyPaid = 15,
    TransferredToDebtCollection = 16,
    DebtCollectionWarningLetter = 17,
    InvoiceSmsReceived = 18,
    InvoiceSmsNotReceived = 19,
    MobilePaySmsReceived = 20,
    MobilePaySmsNotReceived = 21,
    CreditNoteRegistered = 22,
    SmsSent = 23,
    PhoneCall = 24,
    SeeNoteField = 25,
    FeeAdded = 26,
    DigiPostInvoice = 27,
    DigiPostDebtCollectionWarning = 28,
    Email = 29,
    ElectronicInvoice = 30,
    DebtorPortalLinkCreated = 31,
    Forfeited = 32,
    WrittenOff = 33,
    DebtOverviewSentByEmail = 34,
    DirectPaymentSent = 35,
    Ehf = 36,
}

export enum DebtorClaimStage {
    Undefined = 0,
    Invoice = 1,
    Reminder = 2,
    DebtCollectionWarning = 3,
    SentToDebtCollection = 4,
    DebtCollection = 5,
}

export interface PaymentInformationSent extends DebtorClaimEvent {
    recipients?: string[] | undefined;
    content?: string | undefined;
}

export interface ObjectionRegistered extends DebtorClaimEvent {
    reason?: string | undefined;
}

export interface CreditNoteRegistered extends DebtorClaimEvent {
    reason?: string | undefined;
    creditType?: CreditType;
}

export interface ResponseOfDebtorIndex {
    count?: number;
    results?: ResultOfDebtorIndex[] | undefined;
}

export interface ResultOfDebtorIndex {
    score?: number;
    highlights?: Highlights | undefined;
    document?: DebtorIndex | undefined;
}

export interface Highlights {
    name?: string[] | undefined;
    caseNumbers?: string[] | undefined;
}

export interface DebtorIndex {
    id?: string | undefined;
    externalReferenceId?: string | undefined;
    externalReferenceContactId?: string | undefined;
    debtorIds?: string[] | undefined;
    system?: string | undefined;
    name?: string | undefined;
    nationalIdentityNumber?: string | undefined;
    organizationNumber?: string | undefined;
    isOrganization?: boolean | undefined;
    dateOfBirth?: string | undefined;
    extendedAddressLines?: string[] | undefined;
    street?: string | undefined;
    postCode?: string | undefined;
    postArea?: string | undefined;
    country?: string | undefined;
    email?: string | undefined;
    phoneNumbers?: string[] | undefined;
    invoiceNumbers?: string[] | undefined;
    caseNumbers?: string[] | undefined;
    orderNumbers?: string[] | undefined;
    kidNumbers?: string[] | undefined;
    relatedDebtorIds?: string[] | undefined;
    updatedAt?: Date | undefined;
}

export interface DebtorClaim {
    providerSystem?: ProviderSystem;
    claimStage?: DebtorClaimStage;
    paymentType?: PaymentType;
    number?: string | undefined;
    creditorName?: string | undefined;
    date?: Date;
    amount?: number | undefined;
    principalAmount?: number | undefined;
    paidAmount?: number | undefined;
    extrajudicialCostAmount?: number | undefined;
    type?: string | undefined;
    status?: DebtorClaimStatus;
    typeAndStatus?: string | undefined;
    debtCollectionExternalReferenceNumber?: string | undefined;
    externalReferenceId?: number;
    eventsReferenceId?: string | undefined;
    events?: DebtorClaimEvent[] | undefined;
    eventsHaveBeenFetched?: boolean;
    kid?: string | undefined;
    debtorPaymentAccount?: string | undefined;
    debtorId?: string | undefined;
    canRegisterObjection?: boolean;
    canRegisterCreditNote?: boolean;
    canSendPaymentInformation?: boolean;
    forfeitedAt?: Date | undefined;
    isForfeited?: boolean;
    writtenOffAt?: Date | undefined;
    isWrittenOff?: boolean;
    expiredAt?: Date | undefined;
    isExpired?: boolean;
    isTopLevelClaim?: boolean;
    parentClaimIdentificationNumber?: string | undefined;
    closedDate?: Date | undefined;
    isParentCase?: boolean;
    childClaims?: DebtorClaim[] | undefined;
    principalBalanceAmount?: number | undefined;
    interestAmount?: number | undefined;
    costInterestAmount?: number | undefined;
    writingFeesAmount?: number | undefined;
    invoiceFeeAmount?: number | undefined;
    legalFeesAmount?: number | undefined;
    paidPrincipalAmount?: number | undefined;
    interestRate?: number | undefined;
    interestFromDate?: Date | undefined;
    fees?: Fee[] | undefined;
    hasFee?: boolean;
    hasInvoiceFee?: boolean;
    hasNoticeFee?: boolean;
    displayOnDebtOverview?: boolean;
    enteredFinalStateAt?: Date | undefined;
    isInFinalState?: boolean;
    providedServices?: ProvidedService[] | undefined;
    transferredToExternalCollection?: boolean;
    externalDebtCollectionCompany?: DebtCollectionCompany | undefined;
    debtCollectionMissingParentCase?: boolean;
    isTransferredToCollection?: boolean;
    transferredToCollectionAt?: Date | undefined;
    isHalted?: boolean;
    canPostpone?: boolean;
    transactionsHaveBeenFetched?: boolean;
    transactionsOnKid?: Transaction[] | undefined;
    claimInformationTooltip?: { [key: string]: string; } | undefined;
}

export interface LeapClaim extends DebtorClaim {
    providerSystem?: ProviderSystem;
    type?: string | undefined;
    typeAndStatus?: string | undefined;
    isWorkflowCompleted?: boolean;
    canRegisterObjection?: boolean;
    canSendPaymentInformation?: boolean;
    canRegisterCreditNote?: boolean;
    amount?: number | undefined;
    status?: DebtorClaimStatus;
    creditorName?: string | undefined;
    debtorPaymentAccount?: string | undefined;
    dueDate?: Date | undefined;
    caseType?: DebtCollectionCaseType | undefined;
    associatedInvoiceNumbers?: string[] | undefined;
    displayOnDebtOverview?: boolean;
    externalDebtCollectionCompanyId?: number | undefined;
}

export enum DebtorClaimStatus {
    Unspecified = 0,
    Active = 1,
    Paid = 2,
    Forfeited = 3,
    Credited = 4,
    Halted = 5,
    ObjectionReceived = 6,
    Expired = 7,
    Closed = 8,
    ExternalDebtCollection = 9,
}

export enum DebtCollectionCaseType {
    Unknown = 0,
    DebtCollection = 1,
    PreDebtCollection = 2,
    Judicial = 3,
    Disputed = 11,
    Minor = 21,
    MinorRepresentedByGuardian = 22,
    Deviation = 50,
    Converted = 999,
}

export enum PaymentType {
    Undefined = 0,
    Card = 1,
    Cash = 2,
    MobilePay = 3,
    Invoice = 4,
}

export interface Fee {
    amount: number;
    type: FeeType;
}

export enum FeeType {
    InvoiceFee = 0,
    DebtCollectionNoticeFee = 1,
}

export interface ProvidedService {
    externalReferenceId: string | undefined;
    serviceProvider: string | undefined;
    providedAt: Date;
    location: string | undefined;
    serviceProviderIsKnown?: boolean;
}

export interface DebtCollectionCompany {
    id?: number;
    name?: string | undefined;
    contactPerson?: string | undefined;
    displayAddress?: string | undefined;
    displayPhone?: string | undefined;
    displayEmail?: string | undefined;
    webpage?: string | undefined;
}

export interface Transaction {
    id?: number;
    transactionType?: TransactionType;
    date?: Date | undefined;
    description?: string | undefined;
    accountNumber?: string | undefined;
    amount?: number;
}

export enum TransactionType {
    InboundPayment = 0,
    OutboundPayment = 1,
    ReturnFee = 2,
}

export interface DebtorLogItemsResponse {
    logItems?: DebtorLogItem[] | undefined;
    debtCollectionGetFailed?: boolean;
}

export interface DebtorLogItem {
    debtorClaimNumbers?: string[] | undefined;
    debtorClaimIds?: number[] | undefined;
    text?: string | undefined;
    registeredBy?: string | undefined;
    registeredAt?: Date;
    archiveIds?: number[] | undefined;
}

export interface GetLogsByClaimIdsAndNumbersRequest {
    claimIds?: number[] | undefined;
    claimNumbers?: string[] | undefined;
}

export interface MarshalByRefObject {
}

export interface Stream extends MarshalByRefObject {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export interface PowerOfAttorney {
    id?: string;
    debtorId?: string | undefined;
    onBehalfOf?: string | undefined;
    grantTo?: string | undefined;
    duration?: string | undefined;
    includeAccess?: boolean;
    includeAgreement?: boolean;
}

export interface DeactivatePowerOfAttorney {
    debtorId?: string | undefined;
    powerOfAttorneyId?: string;
}

export interface AvailablePowerOfAttorney {
    id?: string;
    debtorId?: string | undefined;
    onBehalfOf?: string | undefined;
    grantTo?: string | undefined;
    duration?: string | undefined;
    includeAccess?: boolean;
    includeAgreement?: boolean;
    registeredBy?: string | undefined;
    registeredAtUtc?: Date;
    active?: boolean;
    deactivatedBy?: string | undefined;
    deactivatedAtUtc?: Date | undefined;
}